import * as React from "react";
import styled from "styled-components";
import Topbar from "./topbar/Topbar";
import { SIDEBAR_WIDTH } from "../settings/metrics";

const MainBody = styled.div`
  flex: 1;
`;

const MainPanel = ({ children, ...otherProps }) => (
  <div {...otherProps}>
    <Topbar />
    <MainBody>{children}</MainBody>
  </div>
);

const StyledMainPanel = styled(MainPanel)`
  padding-left: ${SIDEBAR_WIDTH}px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
`;

export default StyledMainPanel;



// WEBPACK FOOTER //
// ./src/components/MainPanel.js